import React from 'react';
import IconWrapper from '../IconWrapper';
const ArrowRightIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props),
    React.createElement("path", { d: "M12 3l10.001 9.496-10 9.501-.689-.726L20 12.996H2v-1h18l-8.688-8.271z" })));
export default ArrowRightIcon;
//# sourceMappingURL=ArrowRightIcon.js.map